import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { EditorModule } from "@tinymce/tinymce-angular";
import { ServiceModule } from "src/app/services/service.module";
import { ComponentsModule } from "../common-components/components.module";
import { ObservationCommentCellComponent } from "./components/observation-comment-cell/observation-comment-cell.component";
import { ObservationCommentControllerModal } from "./components/observation-comment-controller-modal/observation-comment-controller-modal.component";
import { ObservationCommentFormComponent } from "./components/observation-comment-form/observation-comment-form.component";
import { ObservationCommentsIndicatorComponent } from "./components/observation-comments-indicator/observation-comments-indicator.component";
import { ObservationCommentsComponent } from "./components/observation-comments/observation-comments.component";
import { PaetepDirectiveModule } from "src/app/directives/paetep-directive.module";


@NgModule({
    declarations: [
        ObservationCommentCellComponent,
        ObservationCommentControllerModal,
        ObservationCommentFormComponent,
        ObservationCommentsComponent,
        ObservationCommentsIndicatorComponent
    ],
    exports: [
        ObservationCommentCellComponent,
        ObservationCommentControllerModal,
        ObservationCommentFormComponent,
        ObservationCommentsComponent,
        ObservationCommentsIndicatorComponent
    ],
    imports: [
        CommonModule,
        ComponentsModule,
        PaetepDirectiveModule,
        NgbModule,
        ServiceModule,
        FormsModule,
        ReactiveFormsModule,
        EditorModule
    ]
})
export class ObservationCommentsModule { }
